<template>
  <div class="Firmware-version">
    <pageTitle v-bind="{...pT}" />
    <business-group ref="businessGroup" :loading="loading" :tableConfig="{...tableConfig}"
                    :formConfig="{...formConfig}">
      <template slot="formSlot" slot-scope="formSlot">
        <a-form-item>
          <a-input
            placeholder="请输入设备型号"
            v-decorator="['keyword']"
            style="width: 250px; margin-right: 10px; vertical-align: middle"
          />
        </a-form-item>
      </template>

      <template slot="formRight">
        <a-button type="primary" @click="add">新增</a-button>
      </template>
      <template slot="action" slot-scope="record">
        <a-button type="link" @click="edit(record)">编辑</a-button>
        <a-button type="link" @click="del(record)">删除</a-button>
      </template>
      <template slot="deviceType" slot-scope="record">
        {{ deviceType.enumerate[record.deviceType] }}
      </template>
    </business-group>
    <a-modal destroyOnClose
             :title="title"
             :visible="visible"
             @ok="handleOk('ruleForm')"
             @cancel="handleCancel('ruleForm')"
             :maskClosable="false">
      <a-form-model ref="ruleForm"
                    class="ruleForm"
                    :model="ruleForm"
                    :rules="rules"
                    :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 18 }">

        <a-form-model-item label="设备型号" prop="deviceModel">
          <a-input type="text" placeholder="请输入设备型号" v-model.trim="ruleForm.deviceModel" />
        </a-form-model-item>
<!--        <a-form-model-item label="协议编号" prop="protocolVersion">-->
<!--          <a-input type="text" placeholder="请输入协议编号" v-model="ruleForm.protocolVersion" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item label="设备类型" prop="deviceType">
          <a-select placeholder="请选择设备类型" v-model="ruleForm.deviceType" has-feedback autocomplete="off">
            <a-select-option v-for="el in deviceType.select" :value="el.value" :key="el.value">{{ el.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import pageTitle from "@/components/business/pageTitle";
import businessGroup from "@/components/business/businessGroup";
import formTime from "@/components/business/Form/formTime";
import formSkeleton from "@/components/business/Form/formSkeleton";
import { confirm, tips } from "@/utils/util";
import { deviceType } from "@/utils/pageMaps";
import moment from "moment";

export default {
  components: {
    pageTitle,
    businessGroup,
    formTime,
    formSkeleton
  },
  name: "Firmware-version",

  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("不能为空"));
      } else {
        callback();
      }

    };
    return {
      dateFormat: this.$root.$data.dateFormat,
      deviceType,
      pT: {
        pageTitle: "设备类型"
      },
      title: "编辑",
      tableConfig: {
        url: "bluetoothlight/web/device/models",
        columns: [
        {
            title: "设备编号",
            dataIndex: "modelId",
            key: "modelId",
            width: 220,
            align: "center"
          },
          {
            title: "设备型号",
            dataIndex: "deviceModel",
            key: "deviceModel",
            width: 220,
            align: "center"
          },
          // {
          //   title: "协议编号",
          //   dataIndex: "protocolVersion",
          //   key: "protocolVersion",
          //   align: "center"
          // },
          {
            title: "设备类型",
            key: "deviceType",
            align: "center",
            width: 180,
            scopedSlots: { customRender: "deviceType" }
          },
          {
            title: "绑定用户数",
            dataIndex: "accountNum",
            key: "accountNum",
            width: 180,
            align: "center"

          },
          {
            title: "操作",
            align: "center",
            width: 150,
            scopedSlots: { customRender: "action" }
          }
        ],
        rowKey: "modelId"
      },
      formConfig: {
        formShow: true
      },
      pageLoading: false,
      loading: false,
      visible: false,
      ruleForm: {},
      rules: {
        deviceType: [{ required: true, validator: validatePass, trigger: "change", message: "请选择设备类型" }],
        deviceModel: [{ required: true, validator: validatePass, trigger: "change", message: "请选择设设备型号" }],
        protocolVersion: [{ required: true, validator: validatePass, trigger: "change", message: "请输入协议编号" }]
      },


      refresh: false

    };
  },
  methods: {
    moment,
    add() {

      this.title = "新增设备型号";
      this.modelId = 0;
      this.visible = true;

    },
    edit(record) {
      const { deviceType, deviceModel, protocolVersion, modelId } = record;

      this.ruleForm = { deviceType, deviceModel, protocolVersion, modelId };
      this.title = "编辑设备型号";
      this.visible = true;
    },
    del(record) {
      if (this.loading) return false;
      const rowKey = this.tableConfig?.rowKey;
      if (!rowKey) return false;

      const url = this.tableConfig?.url;
      if (!url) return false;
      const id = record?.[rowKey];
      const payload = {
        okBack: async () => {
          this.loading = true;
          const res = await this.$http("DELETE", `${url}/${id}`);
          const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
            this.refreshData();
          }
          ;
          this.loading = false;
        },
        title: `是否删除该设备类型`
      };
      confirm(this, payload);

    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
    },
    refreshData() {
      this.$refs?.["businessGroup"]?.getData?.();
    },

    handleOk: async function(formName) {

      if (this.loading) return false;
      if (!formName) return false;
      this.$refs[formName].validate(async valid => {
        if (!valid) return false;


        const url = this.tableConfig?.url;
        if (!url) return false;
        this.loading = true;

        const id = this.ruleForm?.[this?.tableConfig?.rowKey] || 0; // 0 是新增 ruleform 有值就是编辑
        const res = await this.$post(`${this.tableConfig.url}/${id}`, this.ruleForm);
        const resultStatus = res?.resultStatus;
        if (resultStatus) {
          tips(this, true);
          this.refreshData();
          this.handleCancel();
          this.visible = false;
        }
        this.loading = false;
      });
    },
    handleCancel(formName) {
      this.title = undefined;
      this.$refs?.[formName]?.resetFields();
      this.ruleForm = {};
      this.visible = false;
    }

  }
};
</script>

<style lang="less">
.ruleForm {
  width: 340px;
  margin: 0 auto;
}

.m-upload {
  .ant-upload-select {
    width: 60px;
    height: 60px;
    border: 1px solid #C3C3C3;
    text-align: center;
    line-height: 60px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}

</style>
